import React, { useEffect, useState } from "react";
import { Calendar, CalendarProvider, Day, useDateAPI } from "@use-date-input/core";
import { adapter as dateAdapter } from "@use-date-input/moment-adapter";
import theme from "./CalendarTheme";
import "./Calendar.scss";
import styled, { useTheme } from "styled-components";
import { BsDot } from "react-icons/bs";
import Icon from "../Icon";
import orangeDot from "./orangeDot.png"
// import {get}

function DayExample() {
    const theme = useTheme()
    //   const isSmallBreakpoint = useMediaQuery(theme.breakpoints.down('sm'))
    //   const numOfColumns = isSmallBreakpoint ? 2 : 4
    //   const numOfVisibleMonths = isSmallBreakpoint ? 2 : 12
    //   const UnavailableDay = styled(Day)(props => ({
    //     background: 'blue',
    //     // backgroundRepeat: 'no-repeat',
    //     // backgroundPosition: 'bottom 6px right 5px',
    //     // backgroundSize: '50% 50%, auto',
    //   }))
    //   let dateDummy=new Date();

    //   const isMonday = date => dateDummy.getDay(date) === 1
    //   function BlockoutMondaysRenderer(props) {
    //     if (dateDummy.getDay(props.day) === 1) {
    //       return (
    //         <span style={{ cursor: 'not-allowed' }}>
    //           <UnavailableDay {...props} disabled />
    //         </span>
    //       )
    //     }
    //     return <Day {...props} />
    //   }
}
const adapter = ({ weekOffset = 0 } = {}) => ({


});


//calender
export default function CalendarDatePicker({ time, onCalendarChange }) {
    // console.log("in calederitem", time)
    let dateArray = ['2023-02-07', '2023-02-13']

   
    const UnavailableDay = styled(Day)(props => ({
        // display: "table-cell !important",
        // borderBottom: "dotted !important",
        // borderBottomWidth:"11px !important",
        // borderRadius:"50% !important",
        // textAlign:"center !important",
        // borderColor: "rgb(255 97 21 / 88%) !important",
        background:`url(${orangeDot}) !important` ,
        backgroundRepeat: "no-repeat !important",
        width: "14px !important",
        height: "31px !important",
        backgroundSize: "14px !important",
        backgroundPosition: "bottom !important",

    }))
    // const UnavailableDay=<BsDot size={30} />
    let testDate = new Date()
    // console.log("test date", testDate)
    const isMonday = date => testDate.getDay(time) === 3


    function BlockoutMondaysRenderer(props) {
        // console.log("propsss,", (props.day).toDate().getDate(), (props.day).toDate().getMonth())
        // console.log("dateArray", dateArray, "props.day", props.day)
        const disableWeekendProps = (props.day) && {
            disabled: true,
            day: undefined,
          }
        //   let className=document.getElementsByClassName(".rCZmA");
        //   console.log("class Name",className)
        let [dates, setDates] = useState([])
        useEffect(() => {
            setDates(time)
        }, [time])
      
        if (dates?.includes((props.day).toDate().getTime())) {
            // console.log("get day ", props.day)
            return (
                <span  >
                    <UnavailableDay {...props} />
                </span>
            )
        }
        return <Day {...props}   />
    }

    return (
        // <Calendar     adapter={dateAdapter} numOfVisibleMonths={1}   theme={theme} onCalendarChange={onCalendarChange} />
        <Calendar components={{
            Day: BlockoutMondaysRenderer,
        }}
            weekOffset={1} adapter={dateAdapter} numOfVisibleMonths={1} theme={theme} onCalendarChange={onCalendarChange} />
        //     <CalendarProvider  adapter={dateAdapter}>
        //     <DayExample />
        //   </CalendarProvider>
    );
}